<app-header></app-header>
<div class="container" *ngIf="blog">
    <div class="row">
        <div class="col-12 col-lg-7 mx-auto">
            <img src="{{ blog.blogImage.largeUrl }}" class="img-fluid rounded" alt="" />
            <h1>{{ blog.title }}</h1>
            <p>Published {{ publishDate }}</p>
            <div class="blog-body" [innerHTML]="stripNewLines(blog.body)"></div>
        </div>
    </div>
</div>
<app-footer></app-footer>
